import { useState } from "react";
import CardTitle from "../../components/styled/CardTitle";
import Button from "../../ui/Button";
import { AddIcon } from "../../utils/icon.utils";
import PaymentAddEdit from "./PaymentAddEdit";
import { convertNumberToWords, currency } from "../../utils/number.utils";
import PaymentList from "./PaymentList";

export default function Payments({ data }) {
  const [editItem, setEditItem] = useState(null);
  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
    }
    setModal((prev) => !prev);
  };

  const handleEdit = (data) => {
    setEditItem(data);
    toggle();
  };

  const customer_attachment_id = data?.id;

  const totalPrice = data?.car?.total ?? 0;
  const totalPayment = data?.totalPayment ?? 0;
  const due = totalPrice - totalPayment;

  return (
    <div className="card border-0">
      <div className="card-body">
        <CardTitle>Payments</CardTitle>
        <div className="row">
          <div className="col-6">
            <div>
              <p className="m-0">Due: {currency(due)}</p>
              <p className="m-0">Inwords: {convertNumberToWords(due)}</p>
            </div>
          </div>
          <div className="col-6">
            <div className="text-end">
              <Button onClick={toggle} name="Add Payment" icon={AddIcon} />
            </div>
          </div>
          <div className="col-12">
            <PaymentList data={data} handleEdit={handleEdit} />
          </div>
          <div className="col-12">
            <div>
              <p className="m-0">Total Paid: {currency(totalPayment)}</p>
              <p className="m-0">Inwords: {convertNumberToWords(totalPayment)}</p>
            </div>
          </div>
        </div>
        {modal && (
          <PaymentAddEdit
            modal={modal}
            toggle={toggle}
            editItem={editItem}
            customer_attachment_id={customer_attachment_id}
            due={due}
          />
        )}
      </div>
    </div>
  );
}
